<template>
    <jt-form
        :alertType="alert.type"
        :alertShow="alert.show"
        :alertMessage="alert.message"
        v-on:create="update()"
        v-on:closeAlert="closeAlert()"
        v-on:clear="clear()"
        title="Novo Grupo"
    >
        <b-overlay :show="showOverlay" rounded="sm">
            <div class="form-row">
                <div class="col-md-6">
                    <b-form-group
                        label="Descrição (Nome do grupo)"
                    >
                        <b-form-input
                            type="text"
                            placeholder="Descrição do grupo"
                            v-model="form.descricao"
                            size="sm"
                        />
                        <small v-if="!$v.form.descricao.required" >Campo requerido</small>
                        <small v-if="!$v.form.descricao.minLength" >A descrição esta muito curta.</small>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group
                        label="Ativo"
                    >
                        <b-form-select v-model="form.ativo" :options="defaultOptions" size="sm" />
                    </b-form-group>
                </div>
            </div>

            <div class="form-row">
                <div class="col-md-4">
                    <b-form-group
                        label="Visivel para os Garçons"
                    >
                        <b-form-select v-model="form.vandroid" :options="defaultOptions" size="sm" />
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group
                        label="Visivel para os clientes"
                    >
                        <b-form-select v-model="form.vweb" :options="defaultOptions" size="sm" />
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group
                        label="Visivel para as estações"
                    >
                        <b-form-select v-model="form.vpc" :options="defaultOptions" size="sm" />
                    </b-form-group>
                </div>
            </div>
        </b-overlay>
    </jt-form>
</template>
<script>
    import jtForm from '@/components/form.vue'
    import { 
        required, 
        numeric, 
        minValue,
        minLength
    } from 'vuelidate/lib/validators'
    export default {
        name: 'novoGrupoView',
        components: {
            jtForm
        },

        data(){
            return {
                showOverlay: false,
                form: {
                    descricao: null,
                    ativo: null,
                    vpc: null,
                    vweb: null,
                    vandroid: null
                },

                alert: {
                    type: 'alert-warning',
                    message: '',
                    show: false
                },

                defaultOptions: [
                    { value: null, text: "Selecione uma opção" },
                    { value: 's', text: "Sim" },
                    { value: 'n', text: "Não" },
                ]
            }
        },

        validations: {
            form: {
                descricao: {
                    required,
                    minLength: minLength(8)
                }
            }
        },

        computed: {
            getToken(){
                return this.$store.getters.getToken
            },

            id(){
                return this.$route.params.id
            }
        },

        methods: {
            getData: function(){
                this.showOverlay = true
                // eslint-disable-next-line
                fetch(server + 'crud/grupo/' + this.id, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data == true){
                            this.form = {
                                descricao: responseJSON.response[0].descricao,
                                ativo: responseJSON.response[0].ativo,
                                vpc: responseJSON.response[0].visualizarpc,
                                vweb: responseJSON.response[0].visualizarweb,
                                vandroid: responseJSON.response[0].visualizarandroid
                            }
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
                    .finally(() => {
                        this.showOverlay = false
                    })
            },
            update: function(){
                this.showOverlay = true
                let formErrors   = this.$v.form.$invalid

                if(formErrors === false){
                    let formBody = []

                    for (let prop in this.form) {
                        if(this.form[prop] !== null){
                            let encodedKey = encodeURIComponent(prop)
                            var encodedValue = encodeURIComponent(this.form[prop])
                            formBody.push(encodedKey + "=" + encodedValue)
                        }
                    }

                    formBody = formBody.join("&")
                    fetch(server + 'crud/grupo/' + this.id, {
                        method: 'PUT',
                        headers: new Headers({
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'token' : this.getToken
                        }),
                        body: formBody
                    })
                        .then(res => (res.json()))
                        .then(response => {
                            if(response.data){
                                this.alert = {
                                    type: 'success',
                                    message: 'Grupo editado',
                                    show: true
                                }
                            }else{
                                this.alert = {
                                    type: 'warning',
                                    message: response.message,
                                    show: true
                                }
                            }
                        })
                        .catch(() => {
                            this.alert = {
                                type: 'danger',
                                message: 'Erro ao editar',
                                show: true
                            }
                        })
                        .finally(() => {
                            this.showOverlay = false
                        })
                }else{
                    this.alert = {
                        type: 'warning',
                        message: 'Existem campos inválidos',
                        show: true
                    }
                }
            },

            closeAlert: function(){
                this.alert = {
                    type: 'alert-warning',
                    message: '',
                    show: false
                }
            },

            clear: function(){
                for(let prop in this.form){
                    this.form[prop] = null
                }
            }
        },

        mounted(){
            this.getData()
        }
    }
</script>